<div class="router-outlet-container">
    <router-outlet></router-outlet>
</div>